export default "__VITE_ASSET__DXyIWj8D__"